import React from 'react';

import classnames from 'classnames';

// components
import { makeStyles } from '@mui/styles';
import {
  RegisteredTypeAhead,
  ManagedTypeAheadBase as TypeAheadBase,
} from '../components/inputs/autocomplete';
import { InputLabelBase } from '../components/inputs/InputLabelBase';
import { withShowable } from '../console/_global/lib/withShowable';

// services
import { useIndustryCodeSearch } from './useIndustryCodeSearch';

const defaultLabelProps = {
  style: { paddingTop: 0 },
};

const InputLabel = withShowable(InputLabelBase);

// Helper function to transform industry data to option format
const toOption = (industry: any) => ({
  label: `${industry.naicsCode} ${
    industry.secondaryIndustry && `[${industry.secondaryIndustry}]`
  }`,
  value: industry.naicsCode,
  meta: {
    secondaryIndustry: industry.secondaryIndustry,
    primaryIndustry: industry.primaryIndustry,
  },
});

const mapToNaicsOptions = (content: any[]) => content.map(toOption);

/**
 * @deprecated use IndustryAutoComplete
 */
export const NaicsCodeAutoComplete = ({
  label,
  labelProps = defaultLabelProps,
  ...props
}: any) => {
  const classes = useStyles();
  const inputClasses = classnames({
    [classes.inline]: labelProps.inline,
  });
  const search = useIndustryCodeSearch(mapToNaicsOptions);
  const handleSearch = React.useCallback(
    ({ input }: any, callback: any) => search(input).then(callback),
    [search]
  );

  return (
    <>
      <InputLabel
        show={Boolean(label)}
        indent
        htmlFor={props.name}
        required={props.required}
        {...labelProps}
      >
        {label || 'Industry Code'}
      </InputLabel>
      <TypeAheadBase
        id="industryCode"
        className={inputClasses}
        onFetch={handleSearch}
        filterOptions={filterOptions}
        {...props}
      />
    </>
  );
};

/**
 * @deprecated use IndustryAutoComplete
 */
export const RegisteredNaicsCodeAutoComplete = ({
  label,
  labelProps = defaultLabelProps,
  ...props
}: any) => {
  const classes = useStyles();
  const inputClasses = classnames({
    [classes.inline]: labelProps.inline,
  });
  const search = useIndustryCodeSearch(mapToNaicsOptions);
  const handleSearch = React.useCallback(
    ({ input }: any, callback: any) => search(`${input}`).then(callback),
    [search]
  );

  return (
    <>
      <InputLabel
        show={Boolean(label)}
        indent
        htmlFor={props.name}
        required={props.required}
        {...labelProps}
      >
        {label || 'Industry Code'}
      </InputLabel>
      <RegisteredTypeAhead
        id="industryCode"
        className={inputClasses}
        onFetch={handleSearch}
        filterOptions={filterOptions}
        {...props}
      />
    </>
  );
};

function filterOptions(options: any) {
  return options;
}

const useStyles = makeStyles(() => ({
  inline: {
    '& input': {
      padding: '6px !important',
    },
  },
}));
